<template>
    <section class="flex font-poppins md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div> 
        <div class=" w-screen pl-10 pr-10 md:p-2">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-xl">MANAGE CARRIERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            
            <div class="mb-10 mt-20 md:m-2 md:text-sm">
                <div class="flex">
                    <i class="fa fa-arrow-left mt-1 text-blue-700"></i>
                    <button class="text-sm ml-4 text-blue-700 cursor-pointer" @click="goBack" >Go Back</button>
                    <p class=" ml-8 font-semibold text-lg">Carriers's Information</p>
                    <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                </div>
            </div>
            
            <section>
                <div class=" flex">
                    <img src="../assets/customer-pic1.png" alt="pic">
                     <!-- <button class="mt-4 cursor-pointer rounded-2xl ml-6  border-blue-400 text-center p-2 bg-green-100 text-green-300 font-semibold" :class="{active:isActive}"
                    @click="toggleStatus">{{isActive ? 'Approved' : rider.status}}

                    </button> -->
                    <button class="mt-4 cursor-pointer rounded-2xl ml-6  border-blue-400 text-center p-2 bg-green-100 text-green-300 font-semibold">{{rider.status}}</button>
                    <!-- <div class="flex ml-6 border bg-gray-200 p-2  text-center mt-4 rounded-xl cursor-pointer">
                        <img class="w-5 h-5 mr-2" src="../assets/message-icon.png"/>
                        <router-link :to="{name: 'email-center', params:{id:rider.email}}">Send Email</router-link>
                    </div> -->
                </div>

            </section>

            <section class="flex justify-between mt-6 text-blue-600">
                <div class="flex">
                    <img src="../assets/user-icon.svg" alt="user-icon">
                    <p class="ml-6">Profile Details</p>
                </div>
                

                <div>
                    <p class="mr-28 md:mr-2 cursor-pointer">Attachment(s)</p>
                </div>
            </section>
            <hr>

            <section class="flex justify-between md:flex-col">
                <div class="mt-6">
                        <div>
                            <div>
                                <div class="flex">
                                    <p> Status: </p>
                                    <p class="ml-10 text-blue-600">{{rider.status}}.</p>
                                </div>
                                <div class="flex mt-4">
                                    <p > Name: </p>
                                    <p class="ml-10 text-blue-600">{{rider.firstName}}  {{rider.lastName}}.</p>
                                </div>
                                 <div class="flex mt-4">
                                    <p > Email: </p>
                                    <p class="ml-10 text-blue-600">{{rider.email}}</p>
                                </div>
                                <div class="flex mt-4">
                                    <p >Phone Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.phone}}.</p>
                                </div>
                                <div v-show="rider.vehicleType" class="flex mt-4">
                                    <p >Vehicle Type:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleType}}.</p>
                                </div>
                                <div v-show="rider.vehicleModel" class="flex mt-4">
                                    <p >Vehicle Model:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleModel}}.</p>
                                </div>
                                <div v-show="rider.vehicleYear" class="flex mt-4">
                                    <p >Vehicle Year:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleYear}}.</p>
                                </div>
                                <div v-show="rider.licenseNumber" class="flex mt-4">
                                    <p >Plate Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.licenseNumber}}.</p>
                                </div>
                                <div v-show="rider.chasisNumber" class="flex mt-4">
                                    <p >Chasis Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.chasisNumber}}.</p>
                                </div>
                                <div v-show="rider.engineNumber" class="flex mt-4">
                                    <p >Engine Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.engineNumber}}.</p>
                                </div>
                                <div v-show="rider.uniqueId" class="flex mt-4">
                                    <p >Unique ID:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.uniqueId}}.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                <div class=" mr-10 mt-6 w-1/3 md:w-full">

                    <div>
                        <div class="flex"> 
                            <div v-if="rider.passport && rider.passport.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                                <p class="text-xs">Passport</p>
                                <a :href="rider.passport" target="_blank"><img class="w-full h-32 " src="../assets/pdf.png" alt="Passport"></a>
                            </div>
                            <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                                <p class="text-xs">Passport</p>
                                <a :href="rider.passport" target="_blank"><img class="w-full h-32 " :src="rider.passport" alt="Passport"></a>
                            </div>

                            <div v-if="rider.idCard && rider.idCard.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                                <p class="text-xs">ID Card</p>
                                <a :href="rider.idCard" target="_blank"><img src="../assets/pdf.png" class="w-full h-32" alt="ID Card"></a>
                            </div>
                            <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                                <p class="text-xs">ID Card</p>
                                <a :href="rider.idCard" target="_blank"><img :src="rider.idCard" class="w-full h-32" alt="ID Card"></a>
                            </div>
                            
                        </div>

                        <div class="flex mt-8">
                            
                           <div v-if="rider.originCertificate && rider.originCertificate.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                                <p class="text-xs">Origin Certificate</p>
                                <a target="_blank" :href="rider.originCertificate"><img class="w-full h-32 " src="../assets/pdf.png" alt="Origin-Certificate"></a>
                            </div>
                            <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                                <p class="text-xs">Origin Certificate</p>
                                <a target="_blank" :href="rider.originCertificate"><img class="w-full h-32 " :src="rider.originCertificate" alt="Origin-Certificate"></a>
                            </div>
                        </div>
                    </div>              
                </div>    
            </section>
           
        </div> 

           
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props: ['id'],

    components : {
        AdminDashboardNav,
        GetDate,
        Notification
    },

    data() {
        return {
            riderInfo: true,
            pendingRiders: true,
            rider: [],
            isLoading: false,
            isActive: false,
            status: "approved"
        }
    },

    mounted() {
        this.getRider();
        this.networkError();
    },

    methods: {
        moment(date) {
            return moment(date);
        },
        toggleStatus() {
            if (!this.isActive) {
                this.isActive = true
            } else{
                this.isActive = false
            }
        },

        goBack() {
            this.$router.go(-1)
        },

        getRider() {
             this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response)=> {
                this.rider = response.data.data
                this.isLoading = false
            })
            .catch((error) => {
                console.log(error)
            })
        },

        
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

